import request from '@/utils/request'

/**
 * 保存应用信息
 * @param {Object} data 应用信息数据
 * @returns {Promise} 返回Promise对象
 */
export function saveApp(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app.saveApp',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取应用列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function listApps(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app.listApps',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存服务信息
 * @param {Object} data 服务信息数据
 * @returns {Promise} 返回Promise对象
 */
export function saveService(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.saveService',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取服务列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function listServices(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.listServices',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 绑定服务
 * @param {Object} data 绑定服务数据
 * @returns {Promise} 返回Promise对象
 */
export function bindingService(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/service.bindingService',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}